import React, {Component} from 'react';
import {withStyles} from '@material-ui/core/styles';

import {FusePageSimple, FuseAnimate} from '@fuse';
import { IconButton, Snackbar} from '@material-ui/core';

import { bindActionCreators } from 'redux';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import * as Actions from 'store/actions';

const styles = theme => ({
    layoutRoot: {},
    cardKategori: {
        textAlign: 'center'
    },
    iconKategori: {
        fontSize: '50px',
        color: '#33691E'
    }
    ,iconKategoriUtama: {
        fontSize: '50px',
        color: '#ffffff'
    }
    ,iconKategoriCancel: {
        fontSize: '50px',
        color: '#D84315'
    },
    PaperKonfirmasiInstrumen: {
        background: '#558B2F',
        borderRadius: '0px',
        color: 'white',
        textAlign: 'center'
    },
    textPaperKonfirmasiInstrumen: {
        color: 'white'
    }
});

class KonfirmasiSelesai extends Component {
    state = {
        error: 0,
        routeParams: {
            pengguna_id: null,
            token: null,
            tahun: localStorage.getItem('tahun')
        },
        persenRata: 0,
        disabledButtonKonfirmasi: true,
        kunci_konfirmasi_instrumen: null,
        SnackbarOpen: false
    }

    goTolink = (url) => {
        this.props.history.push(url);
        // alert('oke ganti');
    };

    KonfirmasiSelesai = () => {
        // alert('tes');

        this.setState({
            ...this.state,
            routeParams: {
                ...this.state.routeParams,
                pengguna_id: JSON.parse(localStorage.getItem('user')).pengguna_id,
                sekolah_id: JSON.parse(localStorage.getItem('user')).sekolah_id
            }
        }, ()=>{
            this.props.setKonfirmasiSelesai(this.state.routeParams).then((result) => {
                // console.log(result);

                this.props.setKunciKonfirmasiInstrumen(result.hasil_konfirmasi.konfirmasi_instrumen_id);
                // console.log(this.props.konfirmasi_instrumen_id);

                if(this.props.konfirmasi_instrumen_id !== null){
                    this.setState({
                        ...this.state,
                        kunci_konfirmasi_instrumen: true
                    });
                }
            });
        })

    }

    getJenjangResponden = (sekolah, pengguna) => {
        let arrReturn = {};
        const peran_id = Number(pengguna.peran_id);
        const bentuk_pendidikan_id = Number(sekolah.bentuk_pendidikan_id);

        if(peran_id === 10){
            arrReturn.responden = 'kepsek';
        }else if(peran_id === 12 || peran_id === 90){
            arrReturn.responden = 'siswa';
        }else if(peran_id === 13){
            arrReturn.responden = 'pengawas';
        }else if(peran_id === 14){
            arrReturn.responden = 'komite';
        }else if(peran_id === 53){
            arrReturn.responden = 'guru';
        }
        
        if(bentuk_pendidikan_id === 5){
            arrReturn.jenjang = 'SD';
        }else if(bentuk_pendidikan_id === 6){
            arrReturn.jenjang = 'SMP';
        }else if(bentuk_pendidikan_id === 13){
            arrReturn.jenjang = 'SMA';
        }else if(bentuk_pendidikan_id === 15){
            arrReturn.jenjang = 'SMK';
        }else if(bentuk_pendidikan_id === 29){
            arrReturn.jenjang = 'SLB';
        }

        return arrReturn;
    }

    componentDidMount = () => {

        // console.log("http://localhost:1747/index.php?integrasi=1&pengguna_id="+JSON.parse(localStorage.getItem('user')).pengguna_id+"&username="+JSON.parse(localStorage.getItem('user')).email+"&kode_registrasi=&sekolah_id="+JSON.parse(localStorage.getItem('user')).sekolah_id+"&versi_app=");

        this.props.setJudul('Sinkronisasi');

        const user = JSON.parse(localStorage.getItem('user'));

        this.props.setLoadingBesar(false);

        this.setState({
            ...this.state,
            routeParams: {
                ...this.state.routeParams,
                sekolah_id: user.sekolah_id,
                pengguna_id: user.pengguna_id,
                token: localStorage.getItem('jwt_token')
            }
        }, () => {
            this.props.simpanJawabanUtamaSemua(this.state.routeParams).then((result)=>{
                this.props.setLoadingBesar(false);
                this.setState({
                    SnackbarOpen: false
                });
            });

            this.props.getSekolah(this.state.routeParams).then((result)=>{

                this.setState({
                    ...this.state,
                    routeParams: {
                        ...this.state.routeParams,
                        pengguna_id: JSON.parse(localStorage.getItem('user')).pengguna_id,
                        token: localStorage.getItem('jwt_token'),
                        jenjang: this.getJenjangResponden(this.props.sekolah, JSON.parse(localStorage.getItem('user'))).jenjang,
                        responden: this.getJenjangResponden(this.props.sekolah, JSON.parse(localStorage.getItem('user'))).responden
                    }
                },()=>{
                    this.props.getRekapKemajuan(this.state.routeParams).then((result)=>{
                        // alert('tes');
                        let persenTotal = 0;
                        let rowTotal = 0;
                        for (let index = 0; index < this.props.rekap_kemajuan.rows.length; index++) {
                            const element = this.props.rekap_kemajuan.rows[index];
                            
                            if(element.jumlah_total > 0){
                                persenTotal = persenTotal + Number(element.persentase);
                                rowTotal++;
                            }   
                        }
        
                        let persenRata = (persenTotal/rowTotal).toFixed(2);
                        let disabledButton = true;
                        if(persenRata < 100){
                            //do nothing
                            // disabledButton = false;
                        }else{
                            disabledButton = false;
                        }

                        // console.log(rowTotal);
        
                        this.setState({
                            ...this.state,
                            persenRata: persenRata,
                            disabledButtonKonfirmasi: disabledButton
                        });
                    });
                });
            });

            // this.props.getKonfirmasiSelesai(this.state.routeParams).then((result)=>{
            //     this.props.setKunciKonfirmasiInstrumen(this.props.konfirmasi_instrumen.konfirmasi_instrumen_id);
            //     // console.log(this.props.konfirmasi_instrumen_id);
            //     if(this.props.konfirmasi_instrumen_id !== null){
            //         this.setState({
            //             ...this.state,
            //             kunci_konfirmasi_instrumen: true
            //         });

            //         // console.log(this.state.kunci_konfirmasi_instrumen);
            //     }else{
            //         this.setState({
            //             ...this.state,
            //             kunci_konfirmasi_instrumen: false
            //         });
            //     }

            //     this.props.getSekolah(this.state.routeParams).then((result)=>{

            //         this.setState({
            //             ...this.state,
            //             routeParams: {
            //                 ...this.state.routeParams,
            //                 pengguna_id: JSON.parse(localStorage.getItem('user')).pengguna_id,
            //                 token: localStorage.getItem('jwt_token'),
            //                 jenjang: this.getJenjangResponden(this.props.sekolah, JSON.parse(localStorage.getItem('user'))).jenjang,
            //                 responden: this.getJenjangResponden(this.props.sekolah, JSON.parse(localStorage.getItem('user'))).responden
            //             }
            //         },()=>{
            //             this.props.getRekapKemajuan(this.state.routeParams).then((result)=>{
            //                 // alert('tes');
            //                 let persenTotal = 0;
            //                 let rowTotal = 0;
            //                 for (let index = 0; index < this.props.rekap_kemajuan.rows.length; index++) {
            //                     const element = this.props.rekap_kemajuan.rows[index];
                                
            //                     if(element.jumlah_total > 0){
            //                         persenTotal = persenTotal+parseInt(element.persentase);
            //                         rowTotal++;
            //                     }   
            //                 }
            
            //                 let persenRata = (persenTotal/rowTotal).toFixed(2);
            //                 let disabledButton = true;
            //                 if(persenRata < 100){
            //                     //do nothing
            //                     // disabledButton = false;
            //                 }else{
            //                     disabledButton = false;
            //                 }

            //                 // console.log(rowTotal);
            
            //                 this.setState({
            //                     ...this.state,
            //                     persenRata: persenRata,
            //                     disabledButtonKonfirmasi: disabledButton
            //                 });
            //             });
            //         });
            //     });
            // });
        });

    }

    render(){
        const {classes} = this.props;

        return (
            <FusePageSimple
                classes={{
                    root: classes.layoutRoot
                }}
                content={
                    <FuseAnimate
                        animation="transition.slideRightBigIn"
                        duration={400}
                        delay={400}
                    >
                        <div>
                            
                        <Snackbar
                            anchorOrigin={{
                                vertical: 'bottom',
                                horizontal: 'right',
                            }}
                            open={this.state.SnackbarOpen}
                            autoHideDuration={6000}
                            onClose={this.handleSnackbarClose}
                            ContentProps={{
                                'aria-describedby': 'message-id',
                            }}
                            message={<span id="message-id">Menyiapkan data sebelum sinkronisasi!</span>}
                            action={[
                                <IconButton
                                  key="close"
                                  aria-label="Close"
                                  color="inherit"
                                  className={classes.close}
                                  onClick={this.handleSnackbarClose}
                                >
                                  {/* <CloseIcon /> */}
                                </IconButton>,
                            ]}
                        />
                        {/* {"http://localhost:1747/index.php?integrasi=1&pengguna_id="+JSON.parse(localStorage.getItem('user')).pengguna_id+"&username="+JSON.parse(localStorage.getItem('user')).email+"&kode_registrasi=&sekolah_id="+JSON.parse(localStorage.getItem('user')).sekolah_id+"&versi_app="} */}
                        <div style={{width: '100%', overflow:'hidden'}} className="konten-utama">
                            <iframe title="integrasi" height="100%" width="100%" style={{height:'700px', width:'100%', overflow:'hidden'}} src={"http://localhost:1747/index.php?progres=100&integrasi=1&pengguna_id="+JSON.parse(localStorage.getItem('user')).pengguna_id+"&username="+JSON.parse(localStorage.getItem('user')).email+"&kode_registrasi=&sekolah_id="+JSON.parse(localStorage.getItem('user')).sekolah_id+"&versi_app="}>
                            </iframe>
                        </div>

                    </div>
                    </FuseAnimate>
                }
            />
        )
    }
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        getRekapKemajuan: Actions.getRekapKemajuan,
        setKonfirmasiSelesai: Actions.setKonfirmasiSelesai,
        setKunciKonfirmasiInstrumen: Actions.setKunciKonfirmasiInstrumen,
        getKonfirmasiSelesai: Actions.getKonfirmasiSelesai,
        getSekolah: Actions.getSekolah,
        setJudul: Actions.setJudul,
        simpanJawabanUtamaSemua: Actions.simpanJawabanUtamaSemua,
        setLoadingBesar: Actions.setLoadingBesar,
    }, dispatch);
}

function mapStateToProps({ Instrumen, Sekolah }) {

    return {
        rekap_kemajuan: Instrumen.rekap_kemajuan,
        hasil_konfirmasi: Instrumen.hasil_konfirmasi,
        konfirmasi_instrumen: Instrumen.konfirmasi_instrumen,
        konfirmasi_instrumen_id: Instrumen.konfirmasi_instrumen_id,
        sekolah: Sekolah.sekolah
    }
}

export default withStyles(styles, { withTheme: true })(withRouter(connect(mapStateToProps, mapDispatchToProps)(KonfirmasiSelesai)));



// WEBPACK FOOTER //
// ./src/main/content/Instrumen/KonfirmasiSelesai.js